var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwish({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1030,
    height: 1080,
    viewBox: "0 0 1030 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1050.45 393.618C1050.45 -41.9283 1451.45 -736.625 1847 -1315.36C1583.3 -1678.49 1362.1 -1942 1362.1 -1942C1362.1 -1942 0.00423512 -315.234 0.00423512 438.262C-0.537476 655.353 50.8956 869.424 150.01 1062.61C249.125 1255.79 393.046 1422.48 569.759 1548.76C746.473 1675.05 950.853 1757.26 1165.84 1788.54C1380.82 1819.82 1600.18 1799.25 1805.59 1728.57C1575.51 1589.68 1385.14 1393.86 1252.87 1160.03C1120.59 926.189 1050.88 662.227 1050.45 393.618V393.618Z",
    fill: "#050E25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwish);
export default __webpack_public_path__ + "static/media/swish.fd7732baf7d086e87b1accae22e47bfb.svg";
export { ForwardRef as ReactComponent };